import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { AccountSwitcherDesktop } from "../AccountSwitcher/AccountSwitcher";
import { BunnyLogo, ClipboardLogo } from "@src/appV2/redesign/components/Logos";
import { FacilityTypes } from "@src/appV2/redesign/utils/facility";
import { routes } from "@src/appV2/redesign/utils/routes";
import { Link } from "react-router-dom";

import { Button } from "@src/appV2/redesign/components/Button";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { useNavHeader } from "../../Shared/Header/useNavHeader";
import { useSession } from "@src/appV2/Auth/api/useSession";

export function AppLayoutHeaderDesktop() {
  const {
    displayHelpButton,
    iconTypeHelpButton,
    onClickHelpButton,

    displayNotificationsButton,
    iconTypeNotificationsButton,
    onClickNotificationsButton,

    displaySettingsButton,
    iconTypeSettingsButton,
    onClickSettingsButton,
  } = useNavHeader();

  const session = useSession();
  const { profile } = session;
  const isEducation =
    profile?.type === FacilityTypes.SCHOOL || profile?.type === FacilityTypes.CHILD_CARE_CENTER;

  const JUST_CLIPBOARD_LOGO_URL = `${process.env.REACT_APP_BASE_PATH ?? "/"}justClipboard.png`;
  const BUNNY_EDUCATION_LOGO_URL = `${process.env.REACT_APP_BASE_PATH ?? "/"}bunnyEducation.png`;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      spacing={5}
      paddingX={5}
      paddingY={2}
    >
      <Link to={routes.enter}>
        <Stack direction="row" alignItems="center" gap={3}>
          <BunnyLogo
            height={50}
            width={50}
            url={isEducation ? BUNNY_EDUCATION_LOGO_URL : undefined}
          />
          <ClipboardLogo
            height={30}
            width={100}
            url={isEducation || !isDefined(profile?.type) ? JUST_CLIPBOARD_LOGO_URL : undefined}
          />
        </Stack>
      </Link>

      <Stack direction="row" alignItems="center" gap={3} height="100%">
        {displayHelpButton && (
          <Button
            variant="linkInverted"
            endIconType={iconTypeHelpButton}
            onClick={onClickHelpButton}
          >
            Help
          </Button>
        )}

        {displaySettingsButton && (
          <IconButton
            variant="linkInverted"
            iconType={iconTypeSettingsButton}
            onClick={onClickSettingsButton}
          />
        )}

        {displayNotificationsButton && (
          <IconButton
            variant="linkInverted"
            iconType={iconTypeNotificationsButton}
            onClick={onClickNotificationsButton}
          />
        )}

        <AccountSwitcherDesktop />
      </Stack>
    </Stack>
  );
}
